import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDownload } = FiIcons;

/**
 * Exports the actual rendered Summary page — not a separately reconstructed
 * report — by cloning its DOM, carrying over the app's real stylesheet, and
 * opening the browser's print dialog (where "Save as PDF" reproduces the
 * page exactly, including background colors/gradients).
 */
function PDFExport({ printAreaId = 'financial-summary-print-area' }) {
  const generatePDF = () => {
    const printArea = document.getElementById(printAreaId);
    if (!printArea) {
      console.error(`PDFExport: could not find #${printAreaId} to export`);
      return;
    }

    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('Please allow pop-ups to download the PDF.');
      return;
    }

    // Clone the live content and strip anything explicitly marked as
    // export-only-exclude (e.g. the Download PDF button itself).
    const clone = printArea.cloneNode(true);
    clone.querySelectorAll('[data-pdf-exclude]').forEach((el) => el.remove());

    // Carry over every stylesheet the app is actually using (Tailwind's
    // compiled CSS, in dev or prod) so the exported page looks identical to
    // what's on screen, colors included.
    const styleTags = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
      .map((el) => el.outerHTML)
      .join('\n');

    const printDoc = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Financial Plan Summary</title>
        <meta charset="utf-8" />
        ${styleTags}
        <style>
          /* Force the browser to keep background colors/gradients when
             printing/saving as PDF instead of stripping them for ink saving. */
          html, body, * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          body { margin: 0; padding: 24px; background: #ffffff; }
          @page { margin: 12mm; }
        </style>
      </head>
      <body>
        ${clone.outerHTML}
      </body>
      </html>
    `;

    printWindow.document.open();
    printWindow.document.write(printDoc);
    printWindow.document.close();

    printWindow.onload = () => {
      // Give the copied stylesheets a brief moment to apply before printing.
      setTimeout(() => printWindow.print(), 300);
    };
  };

  return (
    <button
      data-pdf-exclude="true"
      onClick={generatePDF}
      className="flex items-center space-x-2 px-4 py-2 bg-[#19b48d] text-white rounded-lg hover:bg-[#16a085] transition-colors duration-200"
    >
      <SafeIcon icon={FiDownload} className="text-sm" />
      <span>Download PDF</span>
    </button>
  );
}

export default PDFExport;